import React, { useState } from 'react'
import { Form, App, Input, Modal } from 'antd';
import { useBnsXiangMuXuQiuAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';
import MyEditor from '../../cpn/MyEditor';
function ModuleAdd(props) {
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [info, setInfo] = useState({
        'bxmxq_bxm_id':props.bxm_id,
        'bxmxq_bxm_name': props.bxm_name,
        'bxmxq_cid': props.eu_id,
        'bxmxq_cname': props.eu_name,
        'bxmxq_name': '',
        'bxmxq_content': '',
        bxmxq_yh_id:props.yh_id,
        bxmxq_yh_name:props.yh_name,
    });    
    const [add] = useBnsXiangMuXuQiuAddMutation();
    const handleOk = () => {
        form.validateFields().then(values => {
            add(info).then((res) => {
                if (res.data.Status === 'success') {
                    message.info('新增成功！');
                    setOpen(false);
                    form.resetFields();
                } else if (res.data.Status === "fail") {
                    message.error('新增失败！' + res.data.Message);
                }
            });
        }).catch(error => {
            console.error('表单验证失败:', error);
        });
    };

    return (
        <>
            <a onClick={() => { setOpen(true) }}><PlusSquareOutlined /> 新增模块</a>
            <Modal
                open={open}
                width={800}
                title="新增模块"
                onCancel={() => { setOpen(false); form.resetFields(); }}
                onOk={handleOk}
                
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_module_add"
                    initialValues={{ modifier: 'public' }}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 11 }}
                >
                    <Form.Item
                        name="bxmxq_name"
                        label="模块名称"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请输入模块名称' }]}
                    >
                        <Input
                            onChange={(e) => { setInfo(prevState => ({ ...prevState, bxmxq_name: e.target.value })) }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="bxmxq_content"
                        label="备注"
                        wrapperCol={{ span: 20 }}
                    >
                        <MyEditor
                            onChange={(e) => {
                                setInfo(prevState => ({ ...prevState, bxmxq_content: e }))
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModuleAdd;
